<template>
    <div id="dialog-list-container" style="display: none;">
        <div v-for="(dialog, index) in componentDialogs" :key="index">
            <div v-if="dialog.opened" class="dialog-details">
                <teleport :to="'#dialog_container_' + dialog.name">
                    <component :is="dialog.compName"></component>
                </teleport>
            </div>
        </div>
    </div>
</template>

<script>
import { dialogStore } from "./dialogStore";

let dialogListCmp = {
    name: 'dialogList',
    computed: {
        componentDialogs() {
            let output = [];
            let dialogs = dialogStore().dialogs;
            for (let i in dialogs) {
                if (i === 'length') continue;
                if (dialogs[i].isComponentDialog) output.push(dialogs[i]);
            }
            return output;
        },
    }
};

// componentStore.initComponent(buttonPanelCmp, buttonPanelConfig, '@common/buttonPanel.vue');
export { dialogListCmp };
export default dialogListCmp;
</script>

<style scoped>
</style>
